/**
 * 유틸
 * @category common
 * @example
 * import Utils from '../common/Utils';
 * Utils.namespace('nc.lineage2.sampleApp');
 */
class Utils {
	constructor() {}

	/**
	 * namespace 를 확인후 해당 네임스페이스가 없을 경우 만들어서 리턴
	 * @param  {} _namespace='window.console'
	 * @param  {} _parent=window
	 * @returns {Object}
	 * @example
	 * Utils.namespace('nc.lineage2.sampleApp');
	 * var testApp = new nc.lineage2.sampleApp();
	 */
	static namespace(_namespace = 'window.console', _parent = window) {
		if (typeof _namespace === 'string' && _namespace) {
			let parts = _namespace.split('.');
			for (let i = 0, max = parts.length; i < max; i++) {
				if (!_parent[parts[i]]) _parent[parts[i]] = {};
				_parent = _parent[parts[i]];
			}
		}
		return _parent;
	}

	/**
	 * 객체가 유효한지 확인
	 * @param  {Object} obj={} 탐색 대상 오브젝트
	 * @param  {Array} keys=[] 키네임
	 * @returns {Boolean}
	 * @example
	 * // window.Twitch.Player 객체가 유효한지 확인하는 샘플
	 * Utils.objHasKeys( window, ['Twitch', 'Player'] )
	 */
	static objHasKeys(obj = {}, keys = []) {
		let next = keys.shift();
		return obj[next] && (!keys.length || this.objHasKeys(obj[next], keys));
	}

	/**
	 * 쿠키 세팅
	 * @param  {String} name 쿠키이름
	 * @param  {String} value 쿠키값
	 * @param  {Number} expiredays 만료날짜
	 *
	 * @example
	 * Utils.setCookie('topBanner', 'show', 1);
	 */
	static setCookie(name = '', value = '', expiredays = 1) {
		let todayDate = new Date();
		todayDate.setDate(todayDate.getDate() + expiredays);
		document.cookie = name + "=" + escape(value) + "; path=/; domain=.plaync.com;expires=" + todayDate.toGMTString() + ";";
	}

	/**
	 * 쿠키 확인
	 * @param  {String} name 쿠키이름
	 * @returns {String}
	 * @example
	 * Utils.getCookie('topBanner') == 'show' // true : 쿠키가 입력 되어 있는 상태
	 */
	static getCookie(name = '') {
		let cookies = document.cookie;
		if (cookies.indexOf(name) == -1) return false;
		let cookie = cookies.substr(cookies.indexOf(name));
		cookie = cookie.split(';')[0];
		cookie = cookie.substr(cookie.indexOf('=') + 1);
		return cookie;
	}

	/**
	 * 숫자 앞에 0 붙여주기 ex) '01', '001'
	 * @param  {Number} n
	 * @param  {Number} digits
	 * @returns {String}
	 * @example
	 * Utils.leadingZeros( 3, 2 ) // return '03'
	 */
	static leadingZeros(n, digits) {
		let zero = '';
		const len = n.toString().length;
		let i = 0;
		if (len < digits) {
			for (; i < digits - len; i += 1) {
				zero += '0';
			}
		}
		return zero + n;
	}

	/**
	 * URL 파라미터 키네임으로 값 가져오기
	 * @param  {String} name 키네임
	 * @param  {String} url 필수아님
	 * @returns {String}
	 * @example
	 * Utils.getParamByName('query'); // return '검색어'
	 * Utils.getParamByName('query', 'https://lineage.plaync.com/search/index?query=test'); // return 'test'
	 */
	static getParamByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	/**
	 * URL에 파라미터 추가하기
	 * @param  {String} _key
	 * @param  {String} _val
	 * @param  {String} _url
	 * @returns {String}
	 * @example
	 * Utils.addParam( 'page_no', '43' ),
	 */
	static addParam(_key = 'key', _val = 0, _url = window.location.href) {
		if (window.location.search) { //?파람이 있는 경우

			if (Utils.getParamByName(_key)) { // 해당 키값이 이미 존개하는경우

				let regex = new RegExp(_key + "(=([^&#]*)|&|#|$)");
				_url = _url.replace(regex, `${_key}=${_val}`);
			} else { //해당 키값이 없는경우
				_url += `&${_key}=${_val}`;
			}
		} else { //?파람이 없는 경우
			_url += `?${_key}=${_val}`;
		}
		return _url;
	}

	/**
	 * DateFormat
	 * @param  {String} _date
	 * @returns {String}
	 * @example
	 * Utils.getDate(_d.date);
	 */

	static getDate(_date = '') {
		return new Date(_date).toISOString().split('T')[0].replace(/\-/gi, '.') + '.';
	}

  /**
   * DateFormat
   * @param  {String} _getTime
   * @returns {String}
   * @example
   * Utils.getTime(_d.time);
   */
  static getTime (sec = 0) {
    sec = parseInt(sec, 10);
    let hours   = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - (hours * 3600)) / 60);
    let seconds = sec - (hours * 3600) - (minutes * 60);

    if(hours !== 0 && hours < 10) {
      hours = '0' + hours;
    }
    if(minutes < 10){
      minutes = '0' + minutes;
    }
    if(seconds < 10) {
      seconds = '0' + seconds;
    }

    return (hours ? (hours + ':') : '') + minutes + ':' + seconds;
  }

	/**
	 * URL에 파라미터 삭제하기
	 * @param  {String} _key
	 * @param  {String} _url
	 * @returns {String}
	 * @example
	 * Utils.removeParam( 'page_no'),
	 */
	static removeParam(_key = 'key', _val = '', _url = window.location.href) {
		const param = Utils.getParamByName(_key);

		if (param) { //?파람이 있는 경우
			const values = param.split(',');
			if (values.length > 1) { // 값이 2개 이상일 경우 해당 값만 삭제
				_url = _url.replace(param, values.filter(val => val !== _val).join(''))
			} else { // 값이 하나일 경우 key도 삭제
				_url = _url.split(`&${_key}=${_val}`).join('');
			}
		}
		return _url;
	}

	/**
	 * URL에 HashParams 가져오기
	 * @returns {Object}
	 * @example
	 * Utils.addHash( '', '{key:value}' ),
	 */
	static getHashParams(_uri, _params) {
		const str = window.location.hash;
		if (str.length < 1) return null;

		const tmpArr = str.split('#');
		if (tmpArr.length < 2) return null;

		const paramStr = tmpArr[1],
			params = paramStr.split('&');

		let keyValueArr;
		const obj = {};
		for (let i = 0, max = params.length; i < max; ++i) {
			keyValueArr = params[i].split('=');
			if (keyValueArr.length <= 1) return null;

			obj[keyValueArr[0]] = decodeURIComponent(keyValueArr[1]);

		}
		return obj;
	}

	/**
	 * URL에 HashParams 추가하기
	 * @param  {String} _uri
	 * @param  {Object} _params
	 * @returns {Object}
	 * @example
	 * Utils.addHash( '', '{key:value}' ),
	 */
	static addHashParams(_uri, _params) {
		if (!_params) return _uri;

		let str = '';
		for (const key in _params) {
			if (_params.hasOwnProperty(key)) {
				str += '&' + key + '=' + encodeURIComponent(_params[key]);
			}
		}
		if (str === '') return _uri;

		_uri = _uri.indexOf('#') >= 0 ? _uri + str : _uri + '#' + str.substr(1);
		return _uri;
	}

	static arrayFindPolyfill() {
		if (!Array.prototype.find) {
			Object.defineProperty(Array.prototype, 'find', {
				value: function (predicate) {
					if (this == null) {
						throw new TypeError('"this" is null or not defined');
					}

					var o = Object(this);
					var len = o.length >>> 0;
					if (typeof predicate !== 'function') {
						throw new TypeError('predicate must be a function');
					}
					var thisArg = arguments[1];
					var k = 0;
					while (k < len) {
						var kValue = o[k];
						if (predicate.call(thisArg, kValue, k, o)) {
							return kValue;
						}
						k++;
					}
					return undefined;
				},
				configurable: true,
				writable: true
			});
		}
	}


	/**
	 * 1000 단위 콤마 
	 * import Utils from '../common/Utils';
	 * Utils.addThousandSeparatorCommas( 1000000 )
	 */
    static addThousandSeparatorCommas(_num) {
        return (''+_num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
	


	static makeTime( _time=+new Date(), _now=+new Date() ) {
		/*
			- 0~60초		: 지금 막
			- 1~60분		: n분 전
			- 1시간~24시간	: n시간 전
			- 1일이상		: 2011.05.23.

			- 60000 = 60초
			- 3600000 = 60분
			- 86400000 = 24시간
		*/
		const diff = ( _now - _time ) / 1000,
			past = new Date( _time );

		if ( diff < 60 ) {
			_time = '지금 막';
		} else if ( diff >= 60 && diff < 3600 ) {
			_time = parseInt( diff / 60 ) + '분 전';
		} else if ( diff >= 3600 && diff < 86400 ) {
			_time = parseInt( diff / ( 60 * 60 ) ) + '시간 전';
		} else if ( diff >= 86400 ) {
			let MM = Utils.leadingZeros( past.getMonth()+1, 2 );
			let DD = Utils.leadingZeros( past.getDate(), 2 );
			_time = `${past.getFullYear()}.${MM}.${DD}.`;
		}

		return _time;
	}

} // end of class
export default Utils;